import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { getUsers, setUsers } from '../../actions/user';
import AllUsers from './components/AllUsers';

const messages = defineMessages({
  BACK: {
    id: 'AllUserPage.BACK',
    defaultMessage: 'Zurück',
  },
  ALL_USERS: {
    id: 'AllUserPage.ALL_USERS',
    defaultMessage: 'Alle Benutzer',
  },
});

@connect(
    state => state.userList,
    dispatch => ({
      getUsers: () => getUsers().then(resp => dispatch(setUsers(resp))),
    })
)

class AllUserPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filter: ''
    };
  }

  componentWillMount() {
    this.props.getUsers();
  }

  handleSearchChange = (e) => {
    this.setState({ filter: e.target.value });
  }

  render() {
    const { intl: { formatMessage } } = this.props;
    const { filter } = this.state;
    return (
      <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%', boxSizing: 'border-box' }}>
        
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>
              {formatMessage(messages.ALL_USERS)}
            </h2>
            
            <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ position: 'relative' }}>
                <i className="fa fa-search" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
                <input
                  style={{ padding: '10px 16px 10px 40px', borderRadius: '8px', border: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', color: 'var(--text-color)', outline: 'none', width: '250px', fontSize: '14px' }}
                  type="text"
                  placeholder="Suchen..."
                  value={filter}
                  onChange={this.handleSearchChange}
                />
              </div>

              <Link to="/" style={{ padding: '10px 16px', borderRadius: '8px', backgroundColor: 'var(--btn-default-bg)', color: 'var(--text-color)', border: '1px solid var(--btn-default-border)', textDecoration: 'none', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="fa fa-arrow-left" />
                {formatMessage(messages.BACK)}
              </Link>
            </div>
          </div>

          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '12px', boxShadow: '0 4px 6px -1px var(--panel-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
            <AllUsers items={this.props.results} filter={filter} />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(AllUserPage);
